import React from 'react';

const HemicronLogo = ({ className = "", size = "default" }) => {
  return (
    <div className={`logo-container ${className}`} style={{ display: 'flex', alignItems: 'center' }}>
      <img 
        src="/full_logo.jpeg" 
        alt="Hemicron Logo" 
        style={{ 
          height: size === 'small' ? '24px' : size === 'large' ? '40px' : '32px', 
          width: 'auto', 
          objectFit: 'contain' 
        }}
      />
    </div>
  );
};

export default HemicronLogo;
